import { KRUMAGO } from '../../../s3-assets/Krumago';

const BuildIndustryExperience = () => {
  return (
    <section style={{ padding: '4rem 2rem', backgroundColor: '#ffffff', position: 'relative' }}>
      <div style={{ position: 'relative', width: '100%', overflow: 'hidden', marginBottom: '4rem' }}>
        <img loading="lazy"
          src={KRUMAGO.IMAGES.BILD}
          alt="Bridging The Knowledge Gap"
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
            display: 'block'
          }}
        />
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '50%',
          height: '100%',
          padding: '2rem',
          color: '#ffffff',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          <div style={{
            width: '100%',
            padding: '2rem',
            boxSizing: 'border-box',
            textAlign: 'left',
          }}>
            <h2 style={{
              fontSize: '3.2rem',
              fontWeight: '700',
              color: '#455173',
              fontFamily: 'Poppins, sans-serif',
              margin: '0 0 1rem 0'
            }}>
              Build Industry experience
            </h2>
            <br />
            <h2 style={{
              fontSize: '1rem',
              textAlign: 'justify',

              fontWeight: '700',
              fontFamily: 'Poppins, sans-serif',
              margin: '0',
              maxWidth: '100%',
              color: '#bb4c00',
              lineHeight: '1.5'
            }}>
              At AVPS Academy, we believe that learning should extend beyond the classroom. Our "Build Industry Experience" program is designed to bridge the gap between theoretical knowledge and practical application, equipping you with the real-world skills demanded by top IT companies.    </h2>
          </div>

        </div>
      </div>

      <div style={{ maxWidth: '100%', margin: '0 auto', textAlign: 'left' }}>
        <div style={{ maxWidth: '100%', margin: '0 auto', textAlign: 'left' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '3rem' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', maxWidth: '100%', margin: '0 auto', textAlign: 'left' }}>
              <h2 style={{
                fontSize: '3rem',
                fontWeight: '700',
                color: 'var(--education-secondary, #3B9394)',
                fontFamily: 'Poppins, sans-serif',
                margin: '0'
              }}>
                Real-World Skills
              </h2>
              <h2 style={{
                fontSize: '1.2rem',
                fontWeight: '700',  /* Bold text */
                fontFamily: 'Poppins, sans-serif',
                margin: '0 0 0 0.5rem',
                maxWidth: '100%',
              }}>
                <span style={{ color: 'var(--education-primary, #746EAC)' }}>AVPS Academy</span> offers a unique approach to programmOur curriculum is meticulously crafted to replicate real-world IT environments.
              </h2>


              <h2 style={{
                fontSize: '1.2rem',
                fontWeight: '700',  /* Bold text */
                fontFamily: 'Poppins, sans-serif',
                margin: '0 auto',  /* Center the line below */
                textAlign: 'center',  /* Align text to center */
                maxWidth: '100%',
              }}>
                Through our industry-aligned projects and simulations, you'll gain exposure to
              </h2>


            </div>


          </div>
        </div>



        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1rem',
          flexWrap: 'wrap',
          padding: '2rem',
          boxSizing: 'border-box',
          marginBottom: '8rem'
        }}>
          {[...Array(3)].map((_, index) => (
            <div key={index} style={{
              width: '400px',
              height: '240px',
              padding: '2rem',
              border: '1px solid #ddd',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              backgroundColor: '#F9F9F9',
              transition: 'transform 0.3s ease-in-out',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
            }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: 'var(--education-primary, #746EAC)',
                marginBottom: '1rem'
              }}>
                {index === 0 ? 'Complex IT Challenges' :
                  index === 1 ? 'Cutting-Edge Technologies' :
                    'Collaborative Teamwork'}
              </h3>
              <p style={{
                fontSize: '1rem',  // Font size
                color: '#666'
              }}>
                {index === 0 ? 'Tackle real-world problems that mirror those faced by professionals.' :
                  index === 1 ? 'Work with the latest tools and platforms used in the industry.' :
                    'Develop essential soft skills by working in teams on diverse projects.'}
              </p>
            </div>
          ))}
        </div>




        <div style={{
          position: 'relative',
          backgroundImage: `url(${KRUMAGO.IMAGES.HOW_IT_WORKS})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '4rem 2rem',
          color: '#FFFFFF',
          textAlign: 'center',
          marginBottom: '4rem',
        }}>
          <div style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            zIndex: '2',
            backgroundColor: '#f9f9f9',
            padding: '1rem 2rem',
            borderRadius: '8px',
            transform: 'translateY(-2rem)',
          }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              margin: '0',
              color: 'var(--education-secondary, #3B9394)',
              textAlign: 'center'
            }}>
              The Benefits of Our Approach
            </h2>
          </div>

          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '1',
          }} />

          <div style={{
            position: 'relative',
            zIndex: '2',
            marginTop: '6rem'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-around',
              flexWrap: 'wrap',
              gap: '2rem',
            }}>
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Industry-Driven Projects</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  Collaborate with industry partners on live projects to gain practical experience.
                </p>
              </div>

              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Mentorship from Industry Experts</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  Learn from seasoned professionals who provide guidance and mentorship.
                </p>
              </div>

              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Simulated Work Environments</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  Experience the dynamics of a corporate setting through our simulated workspaces.
                </p>
              </div>

              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Soft Skills Development</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  Enhance your communication, problem-solving, and teamwork abilities.
                </p>
              </div>
            </div>
          </div>
        </div>



        <div style={{
          padding: '4rem 2rem',
          backgroundColor: '#ffffff',
          textAlign: 'left',
        }}>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            marginBottom: '3rem',
            color: 'var(--education-secondary, #3B9394)',
          }}>
            Why Choose AVPS Academy?
          </h2>

          <div style={{ backgroundColor: '#f7f7f7', padding: '2rem 0' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '2rem',
              flexWrap: 'wrap',
            }}>
              <div style={{
                background: 'linear-gradient(45deg, #6a11cb 0%, #2575fc 100%)',
                padding: '3rem 1.5rem',
                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                color: '#fff',
                width: '220px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '1rem',
                }}>Industry-Aligned Curriculum</h3>
                <p style={{ fontSize: '1rem' }}>
                  Stay ahead of the curve with our up-to-date courses.
                </p>
              </div>

              <div style={{
                background: 'linear-gradient(45deg, #f12711 0%, #f5af19 100%)',
                padding: '3rem 1.5rem',
                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                color: '#fff',
                width: '220px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '1rem',
                }}>Hands-On Learning</h3>
                <p style={{ fontSize: '1rem' }}>
                  Learn by doing with our practical approach.
                </p>
              </div>
            </div>
          </div>

        </div>

        <div style={{ textAlign: 'center' }}>  {/* Centered layout */}
          <h2 style={{
            fontSize: '3.2rem',
            fontWeight: '600',
            color: 'var(--education-secondary, #3B9394)',
            marginBottom: '2rem'
          }}>Ready to Build Your IT Career?</h2>
          <h2 style={{
            fontSize: '1.1rem',
            fontWeight: '700',
            fontFamily: 'Poppins, sans-serif',
            margin: '0',
            maxWidth: '100%',
            lineHeight: '1.5',
            marginBottom: '2rem'
          }}>
            Join AVPS Academy and gain the competitive edge you need to succeed. Enroll today and start building your industry experience!    </h2>

          <a href="/products" style={{
            backgroundColor: 'var(--education-primary, #746EAC)', // Subtle CTA button
            color: 'white',
            padding: '1rem 2.5rem',
            borderRadius: '12px',
            textDecoration: 'none',
            display: 'inline-block',
            fontSize: '1.1rem'
          }}>Enroll Now</a>
        </div>

      </div>
    </section>
  );
};

export default BuildIndustryExperience;